<mat-toolbar fxLayout="row" fxLayoutAlign="space-between center">
  <span class="font-size-16 font-weight-400">
    {{ 'LOCATIONS.FILTER.TITLE' | translate }}
  </span>
</mat-toolbar>

<form class="pt-0 filter-content" [formGroup]="filtersForm" fusePerfectScrollbar>
  <div class="pt-16">
    <input
      class="input-legacy"
      formControlName="name_contains"
      placeholder="{{ 'LOCATIONS.FILTER.NAME' | translate }}"
    />
  </div>

  <mat-divider class="mt-16"></mat-divider>
  <company-legacy class="mt-16" formControlName="companyId_in"></company-legacy>

  <mat-divider class="mt-16"></mat-divider>
  <location-group-legacy class="mt-16" formControlName="locationGroupId_in"></location-group-legacy>

  <mat-divider class="mt-16"></mat-divider>
  <div class="pt-16">
    <input
      class="input-legacy"
      formControlName="documentNumber_contains"
      maxlength="20"
      placeholder="{{ 'LOCATIONS.FILTER.DOCUMENT_NUMBER' | translate }}"
      autocomplete="off"
    />
  </div>

  <mat-divider class="mt-16"></mat-divider>
  <div class="filter-subtitle mt-16">
    {{ 'LOCATIONS.FILTER.SITUATION' | translate }}
  </div>
  <mat-form-field class="mt-16 w-100-p" appearance="legacy">
    <mat-select formControlName="archived">
      <mat-option [value]="false">
        {{ 'LOCATIONS.FILTER.ACTIVE' | translate }}
      </mat-option>
      <mat-option [value]="true">
        {{ 'LOCATIONS.FILTER.INACTIVE' | translate }}
      </mat-option>
      <mat-option [value]="''">
        {{ 'LOCATIONS.FILTER.ALL' | translate }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</form>
